/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Factory, FactoryInterface } from "../Factory";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_finderAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_collateralTokenWhitelist",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenFactoryAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_timerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_collateralAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "expiringMultiPartyAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "deployerAddress",
        type: "address",
      },
    ],
    name: "CreatedPotion",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "LiquidationID",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "deployerAddress",
        type: "address",
      },
    ],
    name: "RevitalisedPotion",
    type: "event",
  },
  {
    inputs: [],
    name: "STRICT_LIQUIDATION_LIVENESS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "STRICT_WITHDRAWAL_LIVENESS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "buyerPotions",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "buyerRevitalPots",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "collateralCurrency",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "collateralTokenWhitelist",
    outputs: [
      {
        internalType: "contract AddressWhitelist",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "contractsAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "dataBook",
    outputs: [
      {
        internalType: "uint256",
        name: "expira",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "assetClass",
        type: "string",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "mintedSkPrice",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "mintedAsPrice",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "mintedDep",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "revID",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "amountRevital",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "collateralWithdraw",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "getCurrentTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "mintedDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "rawValue",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "mintedPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "rawValue",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "revitalBook",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "time",
        type: "uint256",
      },
    ],
    name: "setCurrentTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "timerAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "tokenFactoryAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "validExpirationTimestamps",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "expirationTimestamp",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "collateralAddress",
            type: "address",
          },
          {
            internalType: "string",
            name: "priceFeedIdentifier",
            type: "string",
          },
          {
            internalType: "string",
            name: "assetClass",
            type: "string",
          },
          {
            internalType: "string",
            name: "syntheticName",
            type: "string",
          },
          {
            internalType: "string",
            name: "syntheticSymbol",
            type: "string",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
              },
            ],
            internalType: "struct FixedPoint.Unsigned",
            name: "collateralRequirement",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
              },
            ],
            internalType: "struct FixedPoint.Unsigned",
            name: "disputeBondPct",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
              },
            ],
            internalType: "struct FixedPoint.Unsigned",
            name: "sponsorDisputeRewardPct",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
              },
            ],
            internalType: "struct FixedPoint.Unsigned",
            name: "disputerDisputeRewardPct",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
              },
            ],
            internalType: "struct FixedPoint.Unsigned",
            name: "strikePrice",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
              },
            ],
            internalType: "struct FixedPoint.Unsigned",
            name: "assetPrice",
            type: "tuple",
          },
        ],
        internalType: "struct ExpiringMultiPartyCreator.Params",
        name: "params",
        type: "tuple",
      },
      {
        internalType: "address",
        name: "poolAddress",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "nTokens",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "deposit",
        type: "tuple",
      },
    ],
    name: "writeMintPotion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "potionAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "poolAddress",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "nTokens",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "assetPrice",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "dvmBond",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "finalDeposit",
        type: "tuple",
      },
    ],
    name: "revitalisePotion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "revitalID",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "potionAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "poolAddress",
        type: "address",
      },
    ],
    name: "withdrawPotion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "potionAddrs",
        type: "address",
      },
    ],
    name: "getPotionData",
    outputs: [
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "asset",
        type: "string",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "mintSprice",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "mintAprice",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "mintDepo",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "revitID",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "amountRev",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "rawValue",
            type: "uint256",
          },
        ],
        internalType: "struct FixedPoint.Unsigned",
        name: "collateralToWithdraw",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "getContractAddressList",
    outputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "buyer",
        type: "address",
      },
    ],
    name: "getBuyerPotions",
    outputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "buyer",
        type: "address",
      },
    ],
    name: "getBuyerRevitalPots",
    outputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "potionAddress",
        type: "address",
      },
    ],
    name: "getRevitalID",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
];

const _bytecode =
  "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";

type FactoryConstructorParams =
  | [linkLibraryAddresses: FactoryLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Factory__factory extends ContractFactory {
  constructor(...args: FactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, Factory__factory.linkBytecode(linkLibraryAddresses), signer);
    }
  }

  static linkBytecode(linkLibraryAddresses: FactoryLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__ExpiringMultiPartyLib_________________", "g"),
      linkLibraryAddresses["__ExpiringMultiPartyLib_________________"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    _finderAddress: string,
    _collateralTokenWhitelist: string,
    _tokenFactoryAddress: string,
    _timerAddress: string,
    _collateralAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Factory> {
    return super.deploy(
      _finderAddress,
      _collateralTokenWhitelist,
      _tokenFactoryAddress,
      _timerAddress,
      _collateralAddress,
      overrides || {}
    ) as Promise<Factory>;
  }
  getDeployTransaction(
    _finderAddress: string,
    _collateralTokenWhitelist: string,
    _tokenFactoryAddress: string,
    _timerAddress: string,
    _collateralAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _finderAddress,
      _collateralTokenWhitelist,
      _tokenFactoryAddress,
      _timerAddress,
      _collateralAddress,
      overrides || {}
    );
  }
  attach(address: string): Factory {
    return super.attach(address) as Factory;
  }
  connect(signer: Signer): Factory__factory {
    return super.connect(signer) as Factory__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FactoryInterface {
    return new utils.Interface(_abi) as FactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Factory {
    return new Contract(address, _abi, signerOrProvider) as Factory;
  }
}

export interface FactoryLibraryAddresses {
  ["__ExpiringMultiPartyLib_________________"]: string;
}
